import "../styles/loading.css";

export const Loading = ()=>{
    return ( <>
       <div className="loading-block" id="loadingBlock">
    <div className="lb-container">
        <div className="lb-text">Loading</div>
        <div className="lb-loading">
            <div className="lb-circle"></div>
            <div className="lb-circle"></div>
            <div className="lb-circle"></div>
            <div className="lb-shadow"></div>
            <div className="lb-shadow"></div>
            <div className="lb-shadow"></div>
        </div>
    </div>
</div>
      </>);
}